/** What a forum tells the outside world about its own size and pace. */

/** One row of the Security area: a check that ran, passed or not. seen/fix/url come to Pro only. */

import Model from 'flarum/common/Model';
export default class Monitor extends Model {
  type = (() => Model.attribute('type'))();
  name = (() => Model.attribute('name'))();
  url = (() => Model.attribute('url'))();
  tcpHost = (() => Model.attribute('tcpHost'))();
  tcpPort = (() => Model.attribute('tcpPort'))();
  requestMethod = (() => Model.attribute('requestMethod'))();
  alertCondition = (() => Model.attribute('alertCondition'))();
  alertTextLookup = (() => Model.attribute('alertTextLookup'))();
  interval = (() => Model.attribute('interval'))();
  heartbeatGraceSeconds = (() => Model.attribute('heartbeatGraceSeconds'))();
  alerts = (() => Model.attribute('alerts'))();
  /** Pro: alert only once an outage has lasted this many checks in a row (1 = first failure). */
  alertAfterChecks = (() => Model.attribute('alertAfterChecks'))();
  slowThresholdMs = (() => Model.attribute('slowThresholdMs'))();
  realertIntervalMinutes = (() => Model.attribute('realertIntervalMinutes'))();
  slowMinutes = (() => Model.attribute('slowMinutes'))();
  isSlow = (() => Model.attribute('isSlow'))();
  activityAlerts = (() => Model.attribute('activityAlerts'))();
  dnsAlerts = (() => Model.attribute('dnsAlerts'))();
  /** The daily passive security check: opt-out, grade for everyone, findings for Pro. */
  securityCheck = (() => Model.attribute('securityCheck'))();
  securityGrade = (() => Model.attribute('securityGrade'))();
  securityScans = (() => Model.attribute('securityScans'))();
  securityFindings = (() => Model.attribute('securityFindings'))();
  /** Every check that ran (null until the first scan that lists them: use securityFindings then). */
  securityChecks = (() => Model.attribute('securityChecks'))();
  securityLocked = (() => Model.attribute('securityLocked'))();
  securityCheckedAt = (() => Model.attribute('securityCheckedAt', Model.transformDate))();
  securityChangedAt = (() => Model.attribute('securityChangedAt', Model.transformDate))();
  visualAlerts = (() => Model.attribute('visualAlerts'))();
  visualSkipped = (() => Model.attribute('visualSkipped'))();
  visualCheckedAt = (() => Model.attribute('visualCheckedAt', Model.transformDate))();
  visualChangedAt = (() => Model.attribute('visualChangedAt', Model.transformDate))();
  visualBeforeUrl = (() => Model.attribute('visualBeforeUrl'))();
  visualAfterUrl = (() => Model.attribute('visualAfterUrl'))();
  quietDays = (() => Model.attribute('quietDays'))();
  slowSince = (() => Model.attribute('slowSince', Model.transformDate))();
  status = (() => Model.attribute('status'))();
  overLimit = (() => Model.attribute('overLimit'))();
  paused = (() => Model.attribute('paused'))();
  pingToken = (() => Model.attribute('pingToken'))();
  displayUrl = (() => Model.attribute('displayUrl'))();
  uptime24h = (() => Model.attribute('uptime24h'))();
  avgResponseMs = (() => Model.attribute('avgResponseMs'))();
  ongoingIncidentId = (() => Model.attribute('ongoingIncidentId'))();
  startedAt = (() => Model.attribute('startedAt', Model.transformDate))();
  checkedAt = (() => Model.attribute('checkedAt', Model.transformDate))();
  /** Where the newest check ran (a data center, Cloudflare, or this server). */
  checkedFrom = (() => Model.attribute('checkedFrom'))();
  /** Pro, several regions: what each region saw last (single-monitor read only). */
  /** A free owner is shown what Pro adds (once the feature is on). */
  regionsUpsell = (() => Model.attribute('regionsUpsell'))();

  // Expiry tracking. The alert window doubles as the switch: 0 is off.
  sslAlertDays = (() => Model.attribute('sslAlertDays'))();
  sslEndsAt = (() => Model.attribute('sslEndsAt', Model.transformDate))();
  sslIssuer = (() => Model.attribute('sslIssuer'))();
  sslError = (() => Model.attribute('sslError'))();
  domainAlertDays = (() => Model.attribute('domainAlertDays'))();
  domainEndsAt = (() => Model.attribute('domainEndsAt', Model.transformDate))();
  domainRegistrar = (() => Model.attribute('domainRegistrar'))();
  domainError = (() => Model.attribute('domainError'))();

  // Flarum-specific inspection.
  flarumEnabled = (() => Model.attribute('flarumEnabled'))();
  flarumCheckedAt = (() => Model.attribute('flarumCheckedAt', Model.transformDate))();
  flarumReport = (() => Model.attribute('flarumReport'))();
  flarumVitals = (() => Model.attribute('flarumVitals'))();
  ownerName = (() => Model.attribute('ownerName'))();
  isMine = (() => Model.attribute('isMine'))();
  myRole = (() => Model.attribute('myRole'))();
  lastPingAt = (() => Model.attribute('lastPingAt', Model.transformDate))();
  createdAt = (() => Model.attribute('createdAt', Model.transformDate))();
}
flarum.reg.add('linkrobins-lr-monitoring', 'models/Monitor', Monitor);